module.exports = __webpack_public_path__ + "img/direct-costs.234f8861.svg";